import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=f88b2cf4&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=ts"
export * from "./Customers.vue?vue&type=script&lang=ts"
import style0 from "./Customers.vue?vue&type=style&index=0&id=f88b2cf4&prod&lang=scss"
import style1 from "./Customers.vue?vue&type=style&index=1&id=f88b2cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88b2cf4",
  null
  
)

export default component.exports